import type { ReactNode } from 'react';

export const symbol_chair_counter: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M383-674h194l14.91-42H741v-11q0-38.36-27.91-65.68Q685.19-820 646-820H313q-39.19 0-67.09 27.32Q218-765.36 218-727v11h150l15 42ZM302-80q-7.74 0-13.37-6.5Q283-93 283-101q0-14 15.5-28.5T341-155q26-11 53.5-17t55.5-8v-105h-95q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h95v-269h-74q-21 0-32.5-12t-18.3-30H230q-28 0-49-18.5T160-722q0-66.07 43.5-112.04Q247-880 313-880h333q66 0 110 45.96 44 45.97 44 112.04 0 29-21 47.5T729-656h-95.2q-6.8 17-17.8 29.5T584-614h-74v269h94q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-94v105q28 2 55.5 8t53.5 17q27 11 42.5 25.5T677-101q0 8-5.63 14.5T658-80H302Zm81-594h194-194Z"
		/>
	</svg>
);
